import axiosInstance from "../config/axiosInstance"



export const deleteContact = async (id) => {
    const response = await axiosInstance.delete(`/api/admin/delete/contact/${id}`)
    return response
    
}